import agent from "../agent";
import { store } from "../store";
import {
  ASYNC_COUPON_END,
  ASYNC_COUPON_START,
  CHECK_COUPON,
  WRONG_COUPON,
  GET_PRICE,
  RETRIEVING_HEAVY_ITEMS,
  SET_DISCOUNT_CHANGES,
  SHOW_ERROR_ALERT,
  SHOW_SUCCESS_ALERT,
  STORE_HEAVY_ITEMS,
  SENDING_PRICE_FEEDBACK,
  CATCH_SUBMITTING_PRICE_FEEDBACK_ERRORS,
  ASYNC_END,
  START_SENDING_COMMENT,
  END_SENDING_COMMENT,
  GET_PROFILE,
  DISABLE_REFERRAL,
  CHANGE_CALL_CENTER_PHONE_NUMBER,
  SET_PRICE_SUBMIT_BUTTON,
  RETRIEVING_BUTTONS_PRICE_ITEMS,
} from "./actionsTypes";
import i18n from "../i18nextInitiator";
import {
  authenticated,
  bindingParamsToPath,
  errorAlert,
  getBill,
  getOrderStateId,
  paths,
  priceFeedbackModal,
  redirectToTracking,
  refineBill,
  setEditingOrder,
  setUserId,
  successAlert,
  updateDriverLocation,
} from "./actionCreators";
import { push } from "connected-react-router";

/**
 * Translation function.
 * @type {TFunction}
 */
const t = i18n.getFixedT("fa", "general");
/**
 * Retrieve heavy items from backend.
 */
export const getHeavyItems = () => {
  const { order: { order: { vasayeleHazinedar: heavyItems } = {} } = {} } =
    store.getState();

  if (heavyItems.length === 0) {
    store.dispatch({ type: RETRIEVING_HEAVY_ITEMS, value: true });
    agent.Order.getHeavyItems()
      .then((res) => {
        if (res) {
          store.dispatch({ type: STORE_HEAVY_ITEMS, value: res.data });
        }
      })
      .finally(() => {
        store.dispatch({ type: RETRIEVING_HEAVY_ITEMS, value: false });
      });
  }
};
/**
 * Retrieve heavy items by city's lat and log from backend.
 */
export const getHeavyItemsByCity = ({ lat, long }) => {
  store.dispatch({ type: RETRIEVING_HEAVY_ITEMS, value: true });
  agent.Order.getHeavyItemsByCity(lat, long)
    .then((res) => {
      if (res) {
        store.dispatch({ type: STORE_HEAVY_ITEMS, value: res.data });
      }
    })
    .finally(() => {
      store.dispatch({ type: RETRIEVING_HEAVY_ITEMS, value: false });
    });
};
export const getButtonsItemsPrice = ({ lat, long }) => {
  store.dispatch({ type: RETRIEVING_BUTTONS_PRICE_ITEMS, value: true });
  agent.Order.getButtonsItemsPrice(lat, long)
    .then((res) => {
      if (res) {
        store.dispatch({ type: SET_PRICE_SUBMIT_BUTTON, value: res.res });
      }
    })
    .finally(() => {
      store.dispatch({ type: RETRIEVING_BUTTONS_PRICE_ITEMS, value: false });
    });
};
/**
 * Handles submitting a discount coupon
 * @returns {Q.Promise<any>|Promise<{type: string}>|null}
 */
export const checkCoupon = () => {
  store.dispatch({ type: ASYNC_COUPON_START });
  if (!store.getState().order.order.discount_code) return null;

  const checkCouponBody = {
    order_id: store.getState().order.bill.id,
    bon: store.getState().order.order.discount_code,
  };
  return agent.Order.checkCoupon(checkCouponBody)
    .then((res) => {
      if (res && res.status && res.status != 200) {
        const message = (res && res.message) || t("error.connection");
        store.dispatch({
          type: SHOW_ERROR_ALERT,
          message,
        });
        store.dispatch({ type: WRONG_COUPON, message });
        store.dispatch({ type: SET_DISCOUNT_CHANGES, data: res.data });
      } else if (res && res.status == 200) {
        store.dispatch({ type: CHECK_COUPON });
        store.dispatch({
          type: SHOW_SUCCESS_ALERT,
          message: t("discount.accepted"),
        });
        store.dispatch({ type: SET_DISCOUNT_CHANGES, data: res.data });
      }
      return res;
    })
    .catch((res) => {
      const message =
        (res.response && res.response.body && res.response.body.message) ||
        t("error.connection");
      store.dispatch({
        type: SHOW_ERROR_ALERT,
        message,
      });
      store.dispatch({ type: WRONG_COUPON, message });
      store.dispatch({ type: GET_PRICE, payload: res.data });
    })
    .finally(() => store.dispatch({ type: ASYNC_COUPON_END }));
};
/**
 * Retrieve bill from backend
 * @param id
 * @param intercity
 * @returns {*}
 */
export const retrieveBill = (id, intercity) => {
  if (intercity === "intercity")
    return agent.Invoice.billIntercity(id).then((res) => {
      if (res) getBill(res);
      return res;
    });
  else
    return agent.Invoice.bill(id).then((res) => {
      if (res) getBill(res);
      return res;
    });
};

export const submitPriceFeedback = () => {
  const {
    invoice: {
      priceFeedback: { price, provider, description } = {},
      bill: { id },
    } = {},
  } = store.getState();

  const body = {
    price,
    provider,
    description,
    order_id: id,
  };

  store.dispatch({ type: SENDING_PRICE_FEEDBACK, value: true });
  agent.Invoice.priceFeedback(body)
    .then((res) => {
      successAlert(res.message);
      priceFeedbackModal(false);
    })
    .catch((res) => {
      const {
        response: {
          body: { message, errors, errors: { price, provider } = {} } = {},
        } = {},
      } = res;
      if (message === "The given data was invalid.") {
        store.dispatch({
          type: CATCH_SUBMITTING_PRICE_FEEDBACK_ERRORS,
          value: errors,
        });
      }
    })
    .finally(() =>
      store.dispatch({ type: SENDING_PRICE_FEEDBACK, value: false })
    );
};

export const getUpdateData = (params) => {
  agent.Order.edit(params)
    .then((res) => {
      if (res) {
        const order = {
          ...res.order,
          order_id: params.order_id,
          token_id: params.token_id,
          update_from: "webapp",
        };
        setEditingOrder(order);
        window.localStorage.setItem("jwt", res.token.token);
        window.localStorage.setItem("user_id", res.order.user_id);
        agent.setToken(res.token.token);
        setUserId(res.order.user_id);
        authenticated();
      }
      return res;
    })
    .catch((err) => {
      const { order_id, token_id } = err.response.body.errors;

      if (order_id || token_id) errorAlert(t("error.link-expired"));
    })
    .finally(() => store.dispatch({ type: ASYNC_END }));
};

/**
 * Call Rate Order API
 */
export const rateOrder = (comment) => {
  store.dispatch({ type: START_SENDING_COMMENT });
  const {
    invoice: { rate, bill: { id: order_id, workers: workers_rate } = {} },
  } = store.getState();
  const body = { order_id, rate, comment, workers_rate };
  agent.Invoice.rate(body)
    .then((res) => {
      if (res.message) {
        store.dispatch({
          type: SHOW_SUCCESS_ALERT,
          message: res.message ?? t("rating.success-msg"),
        });
        store.dispatch(
          push(bindingParamsToPath(body.order_id, paths.tracking))
        );
      } else {
        store.dispatch({
          type: SHOW_ERROR_ALERT,
          message: res.message || t("error.connection"),
        });
      }
    })
    .catch((err) => {
      const { message = t("error.connection") } = err.response.body;

      store.dispatch({ type: SHOW_ERROR_ALERT, message });
    })
    .finally(() => {
      store.dispatch({ type: END_SENDING_COMMENT });
    });
};

export const callBootApi = () => {
  agent.Auth.boot()
    .then((res) => {
      const {
        data: {
          profile,
          heavy_items,
          nobaar_data: { phone } = {},
          active_orders: { data: activeOrders = [] } = {},
        } = {},
      } = res || {};

      const activeOrder = activeOrders[0];

      if (activeOrder) {
        redirectToTracking(activeOrder.id);
      }

      store.dispatch({ type: GET_PROFILE, profile });
      store.dispatch({ type: CHANGE_CALL_CENTER_PHONE_NUMBER, value: phone });
      store.dispatch({ type: STORE_HEAVY_ITEMS, value: heavy_items });
    })
    .then((res) => {
      if (res && res.data.profile.share_code)
        store.dispatch({ type: DISABLE_REFERRAL });
    });
};
